import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import warningIcon from '../../assets/icons/WARNING.gif';

function DatatypeChangeWarning({open, onOkClick,onClose}) {
    const { t } = useTranslation();
    
    const  handleOkClick = () => {
        onOkClick();
    }

    const handleCancel = () => {
        onClose();
    }

  return (
    <>
     <Dialog open={open} onClose={onClose} maxWidth="xs">
        <DialogTitle className='dialog-header'>
            <div className='title'>{t('BOX_DATATYPE_GRAPHQL_CHANGE_HEADER')}</div>
            </DialogTitle>
        <DialogContent className='modal-content' dividers>
            <div style={{display: 'flex', alignItems: 'center',justifyContent:'center', gap: '10px'}}>
            <img src={warningIcon} alt="warning-icon" style={{ width: 32, height: 32 }} />
            <div>{t('BOX_DATATYPE_GRAPHQL_CHANGE_WARNING')}</div>
            </div>
        </DialogContent>
        <DialogActions>
            <Button variant="outlined" onClick={handleOkClick}>{t('BTN_OK')}</Button>
            <Button variant='outlined' onClick={handleCancel}>{t('BTN_CANCEL')}</Button>
        </DialogActions>
     </Dialog>
    </>
  )
}

export default DatatypeChangeWarning